<div class="w-100 countdown-container d-flex justify-content-around">
  <div class="countdown-segment">
    {{ countdownTimer.days }}
    <span class="segment-label">{{ 'Days' | translate }}</span>
  </div>
  <div class="countdown-segment">
    {{ countdownTimer.hours }}
    <span class="segment-label">{{ 'Hours' | translate }}</span>
  </div>
  <div class="countdown-segment">
    {{ countdownTimer.minutes }}
    <span class="segment-label">{{ 'Minutes' | translate }}</span>
  </div>
  <div class="countdown-segment">
    {{ countdownTimer.seconds }}
    <span class="segment-label">{{ 'Seconds' | translate }}</span>
  </div>
</div>
